<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{ $t('services.workshops.title') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover min-h-[400px] w-full md:aspect-[3]" src="/images/services/workshops-hero.jpg"
        :alt="$t('services.workshops.title')" />
    </div>

    <!-- Main Content -->
    <div class="container mx-auto px-6 py-12">
      <p class="text-sm md:text-base text-gray-600 mb-12 max-w-4xl">
        {{ $t('services.workshops.description') }}
      </p>

      <h2 class="text-xl md:text-2xl font-serif mb-8">{{ $t('services.workshops.types.title') }}</h2>
      <div class="grid md:grid-cols-2 gap-12">
        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.workshops.types.artistic.title') }}</h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.artistic.painting') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.artistic.theater') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.artistic.music') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.artistic.art-therapy') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.artistic.writing') }}
            </li>
          </ul>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/workshops-artistic.jpg" :alt="$t('services.workshops.types.artistic.title')"
            class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>

        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.workshops.types.educational.title') }}</h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.educational.skills') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.educational.creativity') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.educational.socialization') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
              {{ $t('services.workshops.types.educational.environmental') }}
            </li>
          </ul>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/workshops-educational.jpg" :alt="$t('services.workshops.types.educational.title')"
            class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>
      </div>

      <div class="mt-12 p-8 shadow-lg">
        <h2 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.workshops.age-groups.title') }}</h2>
        <div class="grid md:grid-cols-2 gap-12">
          <div>
            <ul class="space-y-3 text-sm md:text-base">
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
                {{ $t('services.workshops.age-groups.children') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
                {{ $t('services.workshops.age-groups.teens') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
                {{ $t('services.workshops.age-groups.youth') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
                {{ $t('services.workshops.age-groups.adults') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-purple-600 shrink-0" />
                {{ $t('services.workshops.age-groups.elderly') }}
              </li>
            </ul>
          </div>
          <!-- <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/workshops-ages.jpg" :alt="$t('services.workshops.age-groups.title')"
            class="rounded-lg w-full h-64 object-cover" /> -->
        </div>
      </div>

      <!-- Contact Section -->
      <div class="bg-gray-100 p-8 rounded-lg mt-16">
        <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('services.workshops.contact.title') }}</h2>
        <p class="text-sm md:text-base text-gray-600 mb-8">
          {{ $t('services.workshops.contact.description') }}
        </p>
        <div class="flex flex-col md:flex-row gap-4">
          <NuxtLink :to="localePath('/contacts')">
            <Button class="bg-purple-600 text-white px-6 py-3 w-full xl:w-auto">
              {{ $t('services.workshops.contact.schedule-btn') }}
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>
